import ProductItem from "./ProductItem";
// import useCartActions from "../hooks/useCartAction";
import useCart from '../hooks/useCart';
import { ProductLoading } from "./SkeletonLoading/ProductsLoading";

function Product({ products, onOpenLoginModal, onOpenCartModal }) {
  const { data: cart, isLoading, error } = useCart();

    // console.log("DEBUG: Full cart object from useCart:", cart); 


  // if (isLoading) return <p className="text-center p-10 font-semibold">Loading Your Cart...</p>;
  if (isLoading) {
        return (
            // <div className="flex justify-center items-center py-12">
            //     <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            // </div>
            <ProductLoading/>
        );
    }
  if (error) return <p className="text-center p-10 text-red-500">Could not load cart.</p>;

  // no products found message if no products available in the selected category
  if (!products || products.length === 0) {
    return (
      // <div className="text-center py-12">
      //   <h3 className="text-lg font-semibold text-gray-600 mb-2">No Products Found</h3>
      //   <p className="text-gray-500">
      //     No products available in the selected category.
      //   </p>
      // </div>
      <ProductLoading/>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 p-4">
      {products.map((p) => {
          const cartItem = cart?.items?.find((item) => item.product_id === p.id);
          return (
              <ProductItem 
                  key={p.id} 
                  product={p} 
                  inCartQty={cartItem?.quantity || 0}
                  cartItemId={cartItem?.id}
                  onOpenLoginModal={onOpenLoginModal}
                  onOpenCartModal={onOpenCartModal}
              />
          );
      })}
    </div>
  );
}

export default Product